import { DAY_CLOSING_APIS } from "@/api_framework/api_config";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback, useState } from "react";
import toast from "react-hot-toast";

import AxiosCurlirize from "axios-curlirize";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useAPIUtils } from "../../useAPIUtils";

export interface IClinicWalletsActionProps {
  abc: string;
}

AxiosCurlirize(axios, () => {});

export const useCashClosingWalletDetails = () => {
  const dispatch = useAppDispatch();
  const { sendCurl } = useCurlLogger();
  const configuration = useConfiguration();
  const { captureError } = useAPIUtils();
  const [clinicCashDetails, setClinicCashListDetails] = useState(null);

  const execute = useCallback(
    async (clinic_id: string) => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        const response: any = await axios
          .get(`${DAY_CLOSING_APIS?.CASH_CLINIC_WALLET_DETAILS?.baseURL}/${clinic_id}`, {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<any>) => {
            if (res.data.status) {
              setClinicCashListDetails(res.data.data);
              return { status: true };
            } else {
              setClinicCashListDetails([]);
              //
            }
          })
          .catch((e: AxiosError) => {
            setClinicCashListDetails([]);
            captureError(e);
            sendCurl(e.config["curlCommand"]);
            if (e.code === "ERR_BAD_REQUEST") {
              //   toast.error("Error while fetching List details");
            }
            return { status: false };
          });
        return response;
      } catch (e: any) {
        setClinicCashListDetails([]);
        captureError(e);
        toast.error("Server Error: " + e.message);
      }
    },
    [dispatch],
  );
  return { execute, clinicCashDetails };
};
